// You can write your custom Javascript here
var $doc = $(document);
var foundInCart_1 = false;
$doc.on('submit', '.form--sample', function (e) {
    e.preventDefault();
    var data = $('.form--sample').serializeArray();
    var variantId = $('#add_sample_product option:selected').val();
    $.getJSON("/cart", function (response) {
        if (response.item_count > 0) {
            response.items.forEach(function (item) {
                if (item.variant_id == variantId) {
                    foundInCart_1 = true;
                }
            });
        }
        if (foundInCart_1) {
            $.ajax({
                url: "/cart/add",
                type: "post",
                dataType: "json",
                data: data
            })
                .then(function (status) {
                    $("#product-added-popup").fadeIn();
                    $('.form--sample .add_sample').hide();
                    $('.form--sample .added_sample').show();
                    setTimeout(function () {
                        $("#product-added-popup").fadeOut();
                    }, 2500);
                });
        } else {
            $.ajax({
                url: "/cart/add",
                type: "post",
                dataType: "json",
                data: data
            })
                .then(function (status) {
                    if (!foundInCart_1) {
                        var itemCountS = $(".cart-count").text();
                        var itemCount = parseInt(itemCountS);
                        $(".cart-count").text(++itemCount);
                    }
                    $("#product-added-popup").fadeIn();
                    $('.form--sample .add_sample').hide();
                    $('.form--sample .added_sample').show();
                    setTimeout(function () {
                        $("#product-added-popup").fadeOut();
                    }, 2500);
                });
        }
    });
});
var sideBarSearch = {};
$doc.ready(function () {

    $doc.keypress(function (e) {
        var side_serch_text_id = $('#ss_text').val();
        var chk_side = $.isEmptyObject(side_serch_text_id);
        var top_search_text_id = $('#ts_text').val();
        var chk_top = $.isEmptyObject(top_search_text_id);
        var side_search_text_query = $('#side_search_text_query').val();
        var chk_query = $.isEmptyObject(side_search_text_query);

        if (e.which == 13) {
            if ($(':focus').is('input, textarea, [contenteditable=true]')) {
                var id = $(':focus').attr('id');
                var pattern = 'ss_text';
                if (id.indexOf(pattern) > -1) {
                    if (!(chk_side)) {
                        $('.search-popup .search-btn').trigger("click");
                    } else if (!(chk_query)) {
                        $('.search-popup .search-btn').trigger("click");
                    }
                } else {
                    if (!(chk_top)) {
                        $('.top_page__search .search-btn').trigger("click");
                    }
                }
            }
        }
    });

});